import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { AdminFacade } from '../facades/admin.facade';

export function adminCleanup<T>(): CanDeactivateFn<T> {
    return () => {
        const adminFacade = inject(AdminFacade);
        adminFacade.clear();

        return true;
    };
}
